import React from 'react';

export default ({ color = '#221CB6', size = 12 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 1.5H3C2.44771 1.5 2 1.94771 2 2.5V10C2 10.5523 2.44771 11 3 11H9C9.5523 11 10 10.5523 10 10V2.5C10 1.94771 9.5523 1.5 9 1.5H8"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 2.5V1C4 0.72386 4.22386 0.5 4.5 0.5H7.5C7.77615 0.5 8 0.72386 8 1V2.5H4Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25 6.25L5.50001 7.5L7.75001 5.25"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
